export default {
  tableHeader: {
    observationCount: 'Počet',
  },
  empty: 'Nenašli sa žiadne pozorovania',
};
